import React from 'react'
import { SearchIcon } from '../../assets/icons/icon'
import { cn } from '../../lib/utils'

const InputSearch = ({ searchText, placeholder, onSearchChange, onSearchDebounced, inputClass, className, iconClass }) => {
  return (
    <div className={cn("flex-1 max-w-md", className)}>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <SearchIcon className={("", iconClass)} />
        </div>
        <input
          type="text"
          value={searchText}
          onChange={(e) => {
            onSearchChange(e.target.value)
            onSearchDebounced?.(e.target.value)
          }}
          placeholder={placeholder}
          className={cn("block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-200 text-gray-900 placeholder-gray-500 focus-within:outline-0", inputClass)}
        />
      </div>
    </div>
  )
}

export default InputSearch
